import { fetchJson, formErrors } from '@/js/services/utils'

import DialogContactUsSuccess from '@/js/components/DialogContactUsSuccess'

export default class AboutPage {
    constructor() {
        this.#initPartnersForm()
    }

    #initPartnersForm() {
        const form = document.querySelector('.about-partners__form')

        if (!form) {
            return
        }

        const successDialog = new DialogContactUsSuccess()

        const submit = form.querySelector('[type=submit]')

        form.addEventListener('submit', async e => {
            e.preventDefault()

            submit.disabled = true
            form.querySelectorAll('.form-control__hint.error').forEach(el => {
                el.remove()
            })

            try {
                const response = await fetchJson(form.action, {
                    method: form.method,
                    body: new FormData(form),
                })

                successDialog.show()
                form.reset()
            } catch (error) {
                formErrors(form, error)
            }

            submit.disabled = false
        })
    }
}
